export default {
  global: {
    next: "Next",
    prev: "Previous",
    selectAll: "Select All",
    action: "Action",
    view: "View",
    day: "Day | Days",
    hour: "Hr | Hrs",
    hourFull: "Hour | Hours",
    minute: "Min",
    second: "Sec",
    quickView: "Quick View",
    viewAll: "View All",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    submit: "Submit",
    setting: "Setting",
    default: "Default",
    choose: "Choose",
    type: "Type",
    areYouSure: "Are you sure?",
    confirmDelete: "Confirm Delete",
    confirmCancel: "Confirm Cancel",
    empty: "Empty Data",
    update: "Update",
    sortBy: "Sort by",
    use: "Use",
    remove: "Remove",
    delete: "Delete",
  },
  paging: {
    prevPage: "Previous Page",
    nextPage: "Next Page",
    totalCount: "Total {0} records",
  },
  errors: {
    serverErr: "System Error: Please try again later!",
    inputError: "Please fill all required fields of informations",
    requiredLogin: "Please login first",
    submitOrderError: "Failed to create order! The system is busy or the network is abnormal, please try again",
    pleaseInput: "Please input {0}",
    pleaseSelect: "Please select {0}",
    pleaseUpload: "Please upload {0}",
    formatError: "{0} format error",
    digits: "Please enter an integer",
  },
  carts: {
    continueShopping: "Continue shopping",
    empty: "Cart Empty",
    totalItemAndTotal: "({0} items) Total after discount",
    buyerInfo: "Orderer information",
    required: "Required",
    optional: "Optional",
    currentlySelected: "You have currently selected",
    items: 'item | items',
    goToEvent: "Event Detail",
    modelInvalid: "Model Invalid",
    ProductOff: "Item off the shelf",
    ProductRemaining: "{0} item remaining | {0} items remaining",
    shippingMethod: "Shipping Methods",
    invalidItem: "Item [{0}] is invalid, please uncheck",
    removedItem: "Item [{0}] has been removed, please uncheck",
    inventoryItem: "Item [{0}] is out of stock, please uncheck",
    abnormalItem: "Item [{0}] is abnormal, please uncheck",
    sameAsBuyer: "Same as Shipping Address",
    shoppingCart: "Shopping Cart",
    gift: "Gift",
    addOn: "Add On",
    differentBuyer: "Different with Buyer Info",
    addToCart: "Add to Cart",
    soldOut: "Sold Out",
    buyNow: "Buy Now",
    giveAwayDone: "Give away done",
    useDiscountCode: "Use Discount Code",
    emptyDiscountCode: "No discount code available",
  },
  orders: {
    title: "My Orders",
    cycleOrders: "Cycle Orders",
    memo: "Order note",
    assortDiscount: "Coupon Discount",
    promDiscount: "Event Discount",
    enable_coin_discount: "Point Discount",
    insuranceFees: "Insurance Fee",
    deliveryFeesDiscount: "Shipping Discount",
    deliveryFees: "Shipping Fee",
    productDetails: "Product details",
    qty: "Qty",
    price: "Price",
    subtotal: "Subtotal",
    total: "Total",
    buyerName: "Name",
    buyerPhone: "Phone",
    toName: "Name",
    toPhone: "Phone",
    toAddress: "Address",
    mart: "Mart",
    paymentMethod: "Payment Methods",
    addressHint: "※ The actual shipping fee will be re-priced according to the delivery area.",
    recipientInfo: "Recipient Info",
    shippingAddress: "Shipping Address",
    shop711: "7-11 Mart",
    shopFami: "Family Mart",
    shopHilife: "Hilife Mart",
    shopOkmart: "OK Mart",
    discount: "Discount On product",
    otherFees: "Other Fee",
    paymentFees: "Payment Fee",
    id: "Order no",
    createAt: "Order date",
    orderNo: "Order#",
    createDate: "Order Date",
    status: "Status",
    orderTotal: "Total",
    empty: "No order information",
    mStatus: {
      pending_payment: "Pending Payment",
      processing: "Processing",
      already_delivery: "Already delivery",
      pending_refund: "Pending Refund",
      done: "Done",
      abnormal_done: "Abnormal Done",
      expired: "Expired",
      active: "Active",
    },
    trackingNo: "Tracking No",
    shippingLogs: "Shipping Logs",
    shippingDetails: "Shipping Details",
    refundDetails: "Refund Details",
    refundMethod: "Refund Method",
    refundAccount: "Refund Account",
    refundQty: "Refund Qty",
    refundAmount: "Refund Amount",
    refundStatus: {
      pending: "Pending",
      processing: "Processing",
      done: "Done",
      canceled: "Canceled",
    },
    cancelOrder: "Cancel this order",
    CancellationByCustomer: "Cancellation by customer",
  },
  invoices: {
    title: "Invoice Options",
    type: "Invoice Type",
    personal: "Personal invoice",
    company: "Company invoice",
    donation: "Donation invoice",
    eturnkey: "Electronic Invoice",
    member: "Member Carrier",
    mobile: "Mobile Carrier",
    mobileCode: "Mobile Carrier Code",
    moica: "MOICA Carrier",
    moicaCode: "MOICA Carrier Code",
    requestPaper: "Request a paper invoice",
    uniformNumbers: "Uniform Numbers",
    companyName: "Company Name",
    carrierCode: "Carrier Code",
    address: "Receive Address",
  },
  products: {
    temperature0: "Normal temperature",
    temperature1: "Refrigerate",
    temperature2: "Frozen",
    priceLowToHigh: "Price low to high",
    priceHighToLow: "Price high to low",
    empty: "No more products",
  },
  promotions: {
    ended: "Ended",
    closed: "Closed",
    groupBuy: "This group buy has",
    countdownClose: "",
    countdownCloseSingle: "Countdown",
    conditionAmount: "Amount",
    conditionQty: "Qty",
    discountTypeAmount: "Save money",
    discountTypePercentage: "% Off",
    less: "Less then",
    newArrival: "New Arrival",
    expireDate: "Expire Date",
    bestSelling: "Best Selling",
    empty: "No more promotions",
    notYetStarted: "Not yet started",
    selectSpec: "View pecification",
    freeGift: "Give a freebie",
    fill: "Fill",
    fillUnit: "pieces",
    gift: "gift",
    discounts: "discounts",
    code: "Discount Code",
    saveCode: "Save Discount Code",
    saveCodeSuccess: "Save discount code Success",
    now: "Now",
    past: "Past",
    memberOnly: "Members Only",
    lowAmount: "Minimum consumption",
    expiryDate: "Expiration Date",
    timesLeft: "Left",
    discount: "Discount",
    maxAmount: "Highest",
    emptyCodes: "No more discount codes",
    subtotal: "Available All",
    categories: "Specify Categories",
    products: "Specified Product",
  },
  coins: {
    title: "Points",
    yourCoins: "Your Points",
    maxCoins: "Can use up to {0} point | Can use up to {0} points",
    useCoin: "Use points",
    useAllCoin: "Use All",
    useHint: "The points can be discounted up to 0 for the item, and it cannot be used to deduct the shipping fee.",
    record: "My Coins",
    earnedCoins: "Earned",
    awaitingCoins: "Awaiting",
    usedCoins: "Used",
    subscriptionCoins: "Subscriptions",
    subscriptionOfflineCoins: "Offline Subscription",
    orderCoins: "Orders",
    orderOfflineCoins: "Offline Orders",
    kolCoins: "KOL Orders",
    bonus: "Coins",
    subscriber: "Subscriber",
    buyer: "Buyer",
  },
  users: {
    title: "Profile Info",
    name: "Contact person name",
    email: "E-Mail",
    phone: "Phone",
    toAddress: "Shipping Address",
    province: "Province",
    city: "City",
    region: "Region",
    road: "Road",
    address: "Address",
    postcode: "Zip code",
    realName: "Real Name",
    identityNo: "Identity No.",
    birthday: "Birthday",
    buyerAddress: "Residence Address",
    buyerAddressHelper: "(same as Identity)",
    buyerAddressDesc: "Neighborhood information is required",
    tel: "Phone",
    updateSuccess: "Update Profile Success",
  },
  accounts: {
    userInfo: "User Info",
    createBankAccount: "Create Bank Account",
    confirmInfo: "Confirm Info",
    identitySuccess: "Bank Setting Success",
    decryptData: "Decrypt Data",
    bankInfoAlert: "The bank account information must be consistent with the ID number, otherwise it may affect future grant rights",
    address: "Common Address",
    addAddress: "Add Common Address",
    selectAddress: "Select Common Address",
    createAddress: "Create Common Address",
    editAddress: "Edit Common Address",
    deleteAddress: "Delete this common address",
    updateAddressSuccess: "Update Common Address Success",
    createAddressSuccess: "Create Common Address Success",
    removeAddressSuccess: "Delete Common Address Success",
    createRefundAccount: "Create Refund Account",
  },
  bankInfo: {
    atmTitle: "Bank ATM Account",
    atmAccountName: "Account Name",
    atmAccountNo: "Account No.",
    accountName: "Account Name",
    accountNo: "Account No.",
    bank: "Bank Name",
    branch: "Branch Name",
    accountImg: "Bank book file",
    accountImgTip: "Bank book front file",
    amount: "Amount",
    expireDate: "Expire Date",
  },
  subscriptions: {
    startAt: "Start Time",
    paidAt: "Paid Time",
    notPaidYet: "Not Paid Yet",
    goToPayment: "Go To Payment",
    changePaymentMethod: "Change Payment Method",
    changePaymentMethodSuccess: "Change Payment Method Success",
    paid: "Paid Record",
    giftRecord: "Free Record",
    record: "My Subscriptions",
  },
}
